module.exports = __webpack_public_path__ + "img/5.fe8b7887.jpg";